// Utilities
import WindowMetrics from '../../utilities/window-metrics';

const settings = {
    classNames: {
        submenuOpen: 'header__submenu--open',
    },
};

export default class Submenu {
    constructor(
        container,
        button,
        menu,
        alwaysOpenOnMobile,
        callbacks = {},
    ) {
        this.container = container;
        this.button = button;
        this.menu = menu;
        this.alwaysOpenOnMobile = alwaysOpenOnMobile === true;
        this.callbacks = callbacks;
        this.isOpen = false;

        // Setup events
        this.container.addEventListener(
            'mouseenter',
            (event) => {
                if (this.alwaysOpenOnMobile) {
                    if (WindowMetrics.isMobile()) {
                        event.preventDefault();
                        event.stopPropagation();

                        // Do nothing
                        return;
                    }
                }

                this.open();
            },
        );

        this.container.addEventListener(
            'mouseleave',
            (event) => {
                if (this.alwaysOpenOnMobile) {
                    if (WindowMetrics.isMobile()) {
                        event.preventDefault();
                        event.stopPropagation();

                        // Do nothing
                        return;
                    }
                }

                this.close();
            },
        );

        this.button.addEventListener(
            'keydown',
            (event) => {
                if (event.key == 'Enter') {
                    event.preventDefault();
                    event.stopPropagation();

                    if (this.alwaysOpenOnMobile) {
                        if (WindowMetrics.isMobile()) {
                            // Do nothing
                            return;
                        }
                    }

                    if (this.isOpen) {
                        this.close();
                    } else {
                        this.open();
                    }
                }
            },
        );

        this.container.addEventListener(
            'touchstart',
            (event) => {
                // Filter out events occurring on elements
                // within our menu
                if (
                    event.target != this.button &&
                    event.target != this.menu
                ) {
                    return;
                }

                event.preventDefault();
                event.stopPropagation();

                if (this.alwaysOpenOnMobile) {
                    if (WindowMetrics.isMobile()) {
                        // Do nothing
                        return;
                    }
                }

                if (this.isOpen) {
                    this.close();
                } else {
                    this.open();
                }
            },
        );
    }

    static get settings() {
        return settings;
    }

    open(immediate = false) {
        if (this.isOpen) {
            return;
        }

        this.isOpen = true;

        // Stop any ongoing animation
        if (this.submenuTimeline) {
            this.submenuTimeline.progress(1);
        }

        this.container
            .classList
            .add(settings.classNames.submenuOpen);

        this.container.style.zIndex = 2;

        const finishCallback = () => {
            this.menu.removeAttribute('style');
        };

        if (immediate) {
            finishCallback();

            // Perform callback
            if (this.callbacks.onOpen) {
                this.callbacks.onOpen(this);
            }

            // Stop here
            return;
        }

        // Animate transition
        this.submenuTimeline = gsap.timeline();
        this.submenuTimeline.from(
            this.menu,
            0.25,
            {
                ease: 'power2.out',
                height: this.menu.firstElementChild.offsetTop,
            },
        );

        this.submenuTimeline.add(
            function() {
                this.submenuTimeline = null;

                finishCallback();
            }.bind(this),
        );

        // Perform callback
        if (this.callbacks.onOpen) {
            this.callbacks.onOpen(this);
        }
    }

    close(immediate = false) {
        if (!this.isOpen) {
            return;
        }

        this.isOpen = false;

        // Stop any ongoing animation
        if (this.submenuTimeline) {
            this.submenuTimeline.progress(1);
        }

        this.container.style.zIndex = '';

        const finishCallback = () => {
            this.menu.removeAttribute('style');
            this.container
                .classList
                .remove(settings.classNames.submenuOpen);
        };

        if (immediate) {
            finishCallback();

            // Perform callback
            if (this.callbacks.onClose) {
                this.callbacks.onClose(this);
            }

            // Stop here
            return;
        }

        // Animate transition
        this.submenuTimeline = gsap.timeline();
        this.submenuTimeline.to(
            this.menu,
            0.25,
            {
                ease: 'power2.out',
                height: this.menu.firstElementChild.offsetTop,
            },
        );

        this.submenuTimeline.add(
            function() {
                this.submenuTimeline = null;

                finishCallback();
            }.bind(this),
        );

        // Perform callback
        if (this.callbacks.onClose) {
            this.callbacks.onClose(this);
        }
    }
}
